import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import XmReview from "../pages/xm-review/page";
import CompareHub from "../pages/compare/page";
import CompareTickmill from "../pages/compare/xm-vs-tickmill/page";
import CompareFxPro from "../pages/compare/xm-vs-fxpro/page";
import CompareIcMarkets from "../pages/compare/xm-vs-icmarkets/page";
import CompareAxi from "../pages/compare/xm-vs-axi/page";
import CompareFxtm from "../pages/compare/xm-vs-fxtm/page";
import Rankings from "../pages/rankings/page";
import Academy from "../pages/academy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/xm-review",
    element: <XmReview />,
  },
  {
    path: "/compare",
    element: <CompareHub />,
  },
  {
    path: "/compare/xm-vs-tickmill",
    element: <CompareTickmill />,
  },
  {
    path: "/compare/xm-vs-fxpro",
    element: <CompareFxPro />,
  },
  {
    path: "/compare/xm-vs-icmarkets",
    element: <CompareIcMarkets />,
  },
  {
    path: "/compare/xm-vs-axi",
    element: <CompareAxi />,
  },
  {
    path: "/compare/xm-vs-fxtm",
    element: <CompareFxtm />,
  },
  {
    path: "/rankings",
    element: <Rankings />,
  },
  {
    path: "/academy",
    element: <Academy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;